// src/pages/Legal/PolitiqueConfidentialite.js
import './LegalPages.css';

import { useDocumentTitle } from '../../hooks/useDocumentTitle';
export default function PolitiqueConfidentialite() {
  useDocumentTitle('Politique de confidentialité');

  return (
    <div className="legal-page">
      <div className="container legal-page__inner">
        <p className="legal-page__overtitle">Protection des données</p>
        <h1 className="legal-page__titre">Politique de confidentialité</h1>
        <hr className="divider-or" style={{ margin: '16px 0 40px' }} />

        <section className="legal-section">
          <h2>1. Responsable du traitement</h2>
          <p>
            Le responsable du traitement des données personnelles est Les Bazars de Keassa (KEASSA),
            micro-entreprise dont le siège social est situé à Paris, France.
            Contact : <strong>contact@lesbazarsdekeassa.com</strong>
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Données collectées</h2>
          <p>Dans le cadre de votre utilisation du site, nous collectons les données suivantes :</p>
          <ul>
            <li><strong>Données d’identification :</strong> nom, prénom, adresse email</li>
            <li><strong>Données de livraison :</strong> adresse postale, téléphone</li>
            <li><strong>Données de commande :</strong> produits commandés, montants, dates</li>
            <li><strong>Données techniques :</strong> adresse IP et type de navigateur, enregistrés
              temporairement dans les journaux de sécurité du serveur afin de détecter les
              tentatives d’intrusion. Aucun suivi de navigation n’est effectué.</li>
          </ul>
          <p>
            <strong>Important :</strong> les données de paiement (numéro de carte bancaire) ne sont
            jamais collectées ni stockées par KEASSA. Elles sont traitées directement par
            Stripe, notre prestataire de paiement certifié PCI-DSS.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Finalités du traitement</h2>
          <p>Vos données personnelles sont collectées pour les finalités suivantes :</p>
          <ul>
            <li>Création et gestion de votre compte client</li>
            <li>Traitement et suivi de vos commandes</li>
            <li>Livraison des produits commandés</li>
            <li>Communication relative à vos commandes (confirmations, suivi)</li>
            <li>Sécurité du site et prévention des abus (limitation des tentatives de connexion)</li>
            <li>Respect de nos obligations légales et réglementaires</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Base légale du traitement</h2>
          <ul>
            <li><strong>Exécution du contrat :</strong> création du compte, traitement et
              livraison de vos commandes</li>
            <li><strong>Intérêt légitime :</strong> sécurité du site, prévention de la fraude
              et des abus</li>
            <li><strong>Obligation légale :</strong> conservation des pièces comptables (5 ans)</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. Durée de conservation</h2>
          <ul>
            <li><strong>Données de compte :</strong> conservées tant que le compte est actif, puis supprimées 3 ans après la dernière activité</li>
            <li><strong>Données de commande :</strong> conservées 5 ans (obligation légale comptable)</li>
            <li><strong>Journaux techniques de sécurité :</strong> 12 mois maximum</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Destinataires des données</h2>
          <p>Vos données personnelles peuvent être transmises aux destinataires suivants :</p>
          <ul>
            <li><strong>Stripe</strong> (traitement des paiements) — certifié PCI-DSS. Les
              données bancaires sont transmises directement du navigateur à Stripe et ne
              transitent jamais par nos serveurs.</li>
            <li><strong>LWS</strong> (hébergement des pages du site) — serveurs situés en France</li>
            <li><strong>PythonAnywhere</strong> (hébergement de l’application et de la base de
              données) — c’est ce prestataire qui héberge vos données de compte et de commande</li>
            <li><strong>Transporteur</strong> (livraison des commandes) — destinataire de
              l’adresse de livraison uniquement</li>
          </ul>
          <p>Aucune donnée n’est vendue ni cédée à des tiers à des fins commerciales.</p>

          <h3>Transfert hors Union européenne</h3>
          <p>
            L’application et la base de données sont hébergées par PythonAnywhere sur une
            infrastructure située aux <strong>États-Unis</strong>. Vos données de compte
            (nom, prénom, adresse électronique) et de commande (adresse de livraison,
            historique) font donc l’objet d’un transfert hors de l’Union européenne, encadré
            par les clauses contractuelles types de la Commission européenne et par le cadre
            de protection des données UE–États-Unis auquel adhèrent les fournisseurs
            d’infrastructure concernés.
          </p>
          <p>
            La migration vers l’infrastructure européenne du même prestataire est identifiée
            comme évolution afin de maintenir l’intégralité des données au sein de l’Union.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Vos droits (RGPD)</h2>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul>
            <li><strong>Droit d’accès :</strong> obtenir une copie de vos données personnelles</li>
            <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
            <li><strong>Droit à l’effacement :</strong> demander la suppression de vos données (depuis votre espace client ou par email)</li>
            <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
            <li><strong>Droit d’opposition :</strong> vous opposer au traitement de vos données</li>
            <li><strong>Droit de retirer votre consentement :</strong> à tout moment, via le lien
              « Gérer mes préférences » en bas de page</li>
          </ul>
          <p>
            Pour exercer ces droits : <strong>contact@lesbazarsdekeassa.com</strong>
            ou directement depuis votre espace client (suppression de compte).
          </p>
          <p>
            Vous pouvez également introduire une réclamation auprès de la CNIL
            (Commission Nationale de l’Informatique et des Libertés) : <strong>www.cnil.fr</strong>
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Sécurité des données</h2>
          <p>KEASSA met en oeuvre les mesures de sécurité suivantes :</p>
          <ul>
            <li>Chiffrement HTTPS sur l’ensemble du site et des échanges avec l’application</li>
            <li>Mots de passe hachés avec l’algorithme bcrypt — jamais stockés en clair</li>
            <li>Authentification par jeton JWT à durée de validité limitée</li>
            <li>Restriction des origines autorisées à dialoguer avec l’application (CORS)</li>
            <li>Validation systématique des données reçues et requêtes paramétrées, afin de
              prévenir les injections</li>
            <li>Limitation du nombre de tentatives de connexion, contre les attaques par
              force brute</li>
            <li>Sauvegardes régulières de la base de données</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>9. Cookies</h2>
          <p>
            Le site n’installe <strong>aucun traceur publicitaire ni outil de mesure
            d’audience</strong>. Les seules informations enregistrées dans votre navigateur
            sont les suivantes :
          </p>
          <ul>
            <li><strong>Session de connexion</strong> — vous maintient connectée d’une page
              à l’autre. Supprimée à la déconnexion.</li>
            <li><strong>Panier d’achat</strong> — conserve vos articles avant la commande.</li>
            <li><strong>Préférences de confidentialité</strong> — mémorise le choix exprimé
              dans le bandeau, pour ne pas vous le redemander à chaque visite.</li>
          </ul>
          <p>
            Ces informations sont strictement nécessaires au fonctionnement du site et sont
            à ce titre exemptées de consentement préalable. Elles restent stockées dans votre
            navigateur et ne sont transmises à aucun tiers.
          </p>
          <p>
            Si un outil de mesure d’audience devait être ajouté, il ne serait activé qu’après
            recueil de votre consentement explicite. Vous pouvez modifier ou retirer votre
            choix à tout moment via le lien <strong>« Gérer mes préférences »</strong> situé
            en bas de chaque page.
          </p>
        </section>

        <p className="legal-page__update">Dernière mise à jour : août 2026</p>
      </div>
    </div>
  );
}